export class WebhookV1StandardPayloadGdsgOperational {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadGdsgOperationalTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadGdsgOperationalArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadGdsgOperational.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadGdsgOperationalTypeEnum;
(function (WebhookV1StandardPayloadGdsgOperationalTypeEnum) {
    WebhookV1StandardPayloadGdsgOperationalTypeEnum["SlaBreached"] = "GDSG_SLA_BREACHED";
    WebhookV1StandardPayloadGdsgOperationalTypeEnum["SystemInaccessible"] = "GDSG_SYSTEM_INACCESSIBLE";
    WebhookV1StandardPayloadGdsgOperationalTypeEnum["WorkerFailure"] = "GDSG_WORKER_FAILURE";
})(WebhookV1StandardPayloadGdsgOperationalTypeEnum || (WebhookV1StandardPayloadGdsgOperationalTypeEnum = {}));
